import { useEffect } from "react";

import PropTypes from "prop-types";

import Table from "../../../../components/Table.jsx";
import { useLazyGetSurveyViewsQuery } from "../../../../redux/service.js";

const SurveyViewsTable = ({ columns, rowSelection = null, filters = {} }) => {
  const [paginateAndFilterSurveyViews, surveyViewsResponse] =
    useLazyGetSurveyViewsQuery();

  useEffect(() => {
    handleTableChange({ current: 1, pageSize: 10 }, filters);
  }, [filters]);

  const handleTableChange = (pagination, tableFilters) => {
    paginateAndFilterSurveyViews({
      page: pagination.current,
      pageSize: pagination.pageSize,
      ...tableFilters,
      ...filters,
    });
  };

  return (
    <Table
      data={surveyViewsResponse.data?.results || []}
      totalCount={surveyViewsResponse.data?.count || 0}
      columns={columns}
      isLoading={
        surveyViewsResponse.isUninitialized || surveyViewsResponse.isFetching
      }
      rowSelection={rowSelection}
      handleTableChange={handleTableChange}
      rowKey={(record) => record.id}
    />
  );
};

SurveyViewsTable.propTypes = {
  columns: PropTypes.array.isRequired,
  rowSelection: PropTypes.object,
  filters: PropTypes.object,
};

export default SurveyViewsTable;
